import { ThemeProvider } from '@emotion/react';
import { Button, Tab, Tabs, TextField } from '@mui/material';
import { createTheme } from '@mui/material/styles'
import { palette } from '@mui/system';
import { useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { PaginationPage } from './../Pagination/Pagination';
import { SingleContent } from './../SingleContent/SingleContent';



export const Search = () => {
    const [searchText, SetSearchText] = useState("");
    const [content, setcontent] = useState()
    const [type, setType] = useState(0);
    const [page, setPage] = useState(1)
    const [numOfPage, setNumOfPages] = useState()

    const darkTheme = createTheme({
        palette: {
            type: "dark",
            primary: {
                main: "#nnn",
            },
        },
    });


    const fetchSearchData = () => {

        fetch(`https://api.themoviedb.org/3/search/${type ? "tv" : "movie"}?api_key=55d3986357276fb32520164149dcabe4&language=en-US&query=${searchText}&page=${page}&include_adult=false`)
            .then(res => res.json())
            .then(json => setcontent(json.results))
            .then(json => setNumOfPages(json.total_pages))


    }

    useEffect(() => {
        window.scroll(0, 0)
        fetchSearchData();
    }, [type, page])


    return (
        <>
            <h1>dhfdlfhlfh</h1>

            <div>
                <ThemeProvider theme={darkTheme}>
                    <div style={{ display: "flex", margin: "15px 0" }}>
                        <TextField style={{ flex: 1 }} className="searchBox" label="Search" variant="filled"
                            onChange={(e) => SetSearchText(e.target.value)} />
                        <Button variant='contained' style={{ marginLeft: 10 }} onClick={fetchSearchData}>
                            <SearchIcon />
                        </Button>
                    </div>
                    <Tabs
                        value={type}
                        indicatorColor="primary"
                        textColor='primary'
                        onChange={(event, newValue) => {
                            setType(newValue)
                            setPage(1)
                        }}
                        style={{ paddingBottom: 5 }}
                    >

                        <Tab style={{ width: "50%" }} label="Search Movies" />
                        <Tab style={{ width: "50%" }} label="Search Tv Series" />
                    </Tabs>
                </ThemeProvider>

                <div className="trending">
                    {content && content.map((ele) =>
                        // console.log(ele)
                        <SingleContent key={ele.id} output={ele} />
                    )}
                    {searchText && !content && (type ? <h2>NO SERIES FOUND</h2> : <h2>NO MOVIES FOUND</h2>)}
                </div>

                <PaginationPage setPage={setPage} />
            </div>
        </>
    )
}